import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo, IHeaderButtonInfo, IRowButtonInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ProjectItemRevisionModel from '../../../models/ProjectItemRevisionModel';
import DataService from "../../../services/data.service";
import { ProjectProps } from "../../../types/IdProps";
import FormatUtils from '../../../utils/FormatUtils';
import AddProjectItemPopup from '../Popups/Project_popup_AddItemRevision';


interface Props extends ProjectProps {
    refresh: () => void
}

const Project_tab_Items: React.FC<Props> = ({ projectId, projectTypeId, refreshDataCounter, refresh }) => {
    const [data, setData] = useState<ProjectItemRevisionModel[]>();
    const [itemStatusTypes, setItemStatusTypes] = useState<string[]>()
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForProjectType } = useAuth();
    const formatUtils = new FormatUtils()

    useEffect(() => {
        getTableData();
    }, [projectId, refreshDataCounter]);

    function getTableData() {
        DataService.get<ProjectItemRevisionModel[]>('api/v1/ProjectItemRevisions/ByProject/' + projectId)
            .then(response => {
                let statusTypes: string[] = []
                response.forEach(x => {
                    x.itemRevision.itemRevisionStatuses.forEach(y => {
                        var endDateStatusType = formatUtils.dateFromString(y.itemStatus.itemStatusType.endDate)
                        var endDateStatus = formatUtils.dateFromString(y.itemStatus.endDate)
                        if ((endDateStatusType === undefined || endDateStatusType > new Date(Date.now())) &&
                            (endDateStatus === undefined || endDateStatus > new Date(Date.now()))) {
                            if (y.isLatest && statusTypes.includes(y.itemStatus.itemStatusType.name) == false) {
                                statusTypes.push(y.itemStatus.itemStatusType.name);
                            }
                        }
                    })
                });

                setItemStatusTypes(statusTypes)
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function getStatusColor(projectItemRevision: ProjectItemRevisionModel, colInfo: IColInfo): string | undefined {
        if (projectItemRevision.itemRevision && projectItemRevision.itemRevision.itemStatus)
            return projectItemRevision.itemRevision.itemStatus.color;
    }

    function getBrands(projectItemRevision: ProjectItemRevisionModel, colInfo: IColInfo): string | undefined {
        if (projectItemRevision.itemRevision && projectItemRevision.itemRevision.item.itemBrands)
            return projectItemRevision.itemRevision.item.itemBrands.map(x => x.brand.name).join(', ');
    }

    function getEmployees(projectItemRevision: ProjectItemRevisionModel, colInfo: IColInfo): string | undefined {
        if (projectItemRevision.itemRevision && projectItemRevision.itemRevision.itemEmployees)
            return projectItemRevision.itemRevision.itemEmployees.map(x => x.functionalRole.name + ': ' + x.employee.name).join(', ');
    }

    function getStatus(projectItemRevision: ProjectItemRevisionModel, colInfo: IColInfo): string | undefined {
        const status = colInfo.dataProp;
        let result = ''

        projectItemRevision.itemRevision.itemRevisionStatuses.forEach(y => {
            var endDateStatus = formatUtils.dateFromString(y.itemStatus.endDate)
            if (endDateStatus === undefined || endDateStatus > new Date(Date.now())) {
                if (y.isLatest == true && y.itemStatus.itemStatusType.name == status) {
                    result = y.itemStatus.name;
                }
            }
        })

        return result;
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ProjectItemRevisions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
                refresh();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'itemRevisionId', visible: false },
        { dataProp: 'col-1', getCellBackgroundColor: getStatusColor, sort: false, width:5 },
        { title: 'Item Nr', dataProp: 'itemRevision.item', dataType: 'item', sort: 'asc' },
        { title: 'Revision', dataProp: 'itemRevision.revisionNumber', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Colors', dataProp: 'itemRevision.colors', dataType: 'workflowItemRevisions', sort: false },
        { title: 'Naam', dataProp: 'itemRevision.item.name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Design phase', dataProp: 'itemRevision.designPhase', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Brands', getCellData: getBrands },
        { title: 'Employees', getCellData: getEmployees },
        { title: 'Added on', dataProp: 'createdOn', dataType: 'datetime' },
        { title: 'Added by', dataProp: 'createdByUser', dataType: 'user' },
    ];

    if (itemStatusTypes) {
        itemStatusTypes.forEach((value, index) => {
            colInfos.push({ title: value, dataProp: value, getCellData: getStatus, filterInfo: { filterType: 'CheckboxList', filterMenuWidth: 325 } });
        });
    }

    if (isAuthorizedForProjectType(ApplicationFunctions.UpdateProject, projectTypeId)) {
        let headerButtons: IHeaderButtonInfo[] = [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }];
        let rowButtons: IRowButtonInfo[] = [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }];
        colInfos.push({ headerButtons: headerButtons, rowButtons: rowButtons });
    }

    if (!itemStatusTypes)
        return null

    return (
        <>
            <DataTable
                name='dtProjectItemRevisions'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Itemrevision'
                navigateUrl='/plm/Items/ItemRevision/'
            />
            <AddProjectItemPopup projectId={projectId} projectTypeId={projectTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); refresh(); }} />
        </>
    );
}
export default Project_tab_Items;